import {
  useCurrentClientManager,
  useEntitiesThatCannotOnboardSubentities,
} from '@cko/dashboard-shared';
import { useQuery } from '@tanstack/react-query';

import { API_PATHS } from '../../../../environment/apiPaths';
import {
  useProcessingChannelsWithMotoFetcher,
  UseProcessingChannelsWithMotoQueryKey,
} from './useProcessingChannelsWithMotoFetcher';
import { mapResponseToProcessingChannels } from './selector';
import { ProcessingChannel, ProcessingChannelsResponseBody } from './types';

export const useProcessingChannelsWithMoto = () => {
  const { client, entity } = useCurrentClientManager();
  const acceptedEntityIds = useEntitiesThatCannotOnboardSubentities();
  const entityIds = entity?.id ? [entity.id] : acceptedEntityIds;

  const queryKey: UseProcessingChannelsWithMotoQueryKey = [
    API_PATHS.processingChannelsApiBasePath,
    {
      clientId: client?.id,
      entityId: entity?.id,
      entityIds,
      processingChannelFeature: 'payment-moto',
    },
  ];

  const isEnabled = entityIds.length > 0;

  return useQuery<
    ProcessingChannelsResponseBody,
    Error,
    ProcessingChannel[],
    UseProcessingChannelsWithMotoQueryKey
  >(queryKey, useProcessingChannelsWithMotoFetcher(), {
    enabled: isEnabled,
    select: mapResponseToProcessingChannels,
  });
};
